import { TextAlign } from '@tiptap/extension-text-align';

export const CustomTextAlign = TextAlign.configure({
   types: ['tableCell', 'tableHeader'],
   alignments: ['left', 'center', 'right'],
});
